import type { FC } from "react";
import { LoadingState } from "@/components/podkit/loading/LoadingState";
import { useOrganization } from "@/queries/organization-queries";
import { OrganizationTier } from "gitpod-next-api/gitpod/v1/organization_pb";
import CreditUsagePage from "@/routes/settings/organization/credit-usage/CreditUsagePage";
import EnterpriseUsagePage from "@/routes/settings/organization/enterprise-usage/EnterpriseUsagePage";

export const UsagePageRouter: FC = () => {
    const { data: organization, isLoading } = useOrganization();

    if (isLoading) {
        return <LoadingState />;
    }

    if (organization?.tier === OrganizationTier.ENTERPRISE) {
        return <EnterpriseUsagePage />;
    }

    return <CreditUsagePage />;
};
